import { TelegramContext } from "./TelegramContext";
import getIsTgAuth from './utils/getIsTgAuth';

function TelegramProvider({ children }) {

    const value = {
        initData: window.Telegram?.WebApp?.initData,
        isTgAuth: getIsTgAuth(),
        tgId: window.Telegram?.WebApp?.initDataUnsafe?.user?.id,
    };

    return <TelegramContext.Provider value={value}>{children}</TelegramContext.Provider>;
}

export default TelegramProvider;
